// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rlIW","colMin":"styles_colMin__3k3Rq"};